export const ECOM_INITIATE_PAYMENT = '/api/public/ecom/v1/payment/initiate';
export const ECOM_OTP_SEND = '/api/public/ecom/v1/otp/send';
export const ECOM_OTP_VERIFY = '/api/public/ecom/v1/otp/verify';
export const ECOM_INVENTORY_STATUS = '/api/public/ecom/v1/product/inventories';
export const ECOM_GET_PAYMENT_STATUS = '/api/public/ecom/v1/payment/status/';
export const ECOM_PRODUCT_DETAIL = '/cms/product-detail/';
export const ECOM_PRODUCTS_DETAIL = '/cms/products-detail';
export const ECOM_HEADER_DETAIL = '/cms/header';
export const ECOM_CATEGORY_DETAIL = '/cms/category-detail/';
export const ECOM_STATIC_CONTENT = '/cms/static-page/detail';
export const ECOM_SUB_CATEGORY_DETAIL = '/cms/sub-category-detail/';
export const ECOM_SEARCH_RESULT_PAGE = '/cms/search-result-page/';
export const ECOM_SEARCH_RESULT = '/api/public/v1/search/plp';
export const ECOM_CMS = '/cms/';
export const ECOM_SINGLE_PRODUCT_PRICES = '/api/public/v1/price';
export const ECOM_FOOTER_DETAIL = '/cms/footer';
export const ECOM_PINCODE_AVAILABILITY = '/api/public/ecom/v1/product/pincode-availability';
export const ECOM_LOGOUT = '/api/account/signout';
export const ECOM_STORE_DETAIL = '/cms/store-detail/';
export const ECOM_SERVICE_PRODUCT_CHECKOUT = '/api/cart/service-product-checkout';
// Cart
export const ECOM_ADD_TO_CART = '/api/public/v1/cart/cart-item';
export const ECOM_GET_CART = '/api/public/v1/cart';
export const ECOM_UPDATE_CART_ITEM = '/api/public/v1/cart/cart-item';
export const ECOM_DELETE_CART_ITEM = '/api/public/v1/cart/{cartId}/cart-item';

// Address
export const ECOM_GET_ADDRESS = '/api/account/address';

// Checkout
export const ECOM_CHECKOUT = '/api/v1/checkout';

// search
export const ECOM_SEARCH = '/api/public/v1/search';

//coupons
export const ECOM_FETCH_COUPONS = '/api/public/v1/coupon/list';
export const ECOM_INDEX_COUPONS = '/api/public/v1/coupon/index';
export const ECOM_VALIDATE_COUPONS = '/api/public/v1/coupon/validate';
// Order
export const ECOM_ORDER_CONFIRMATION = '/api/v1/order/confirmation/';
export const ECOM_ORDER_LIST = '/api/v1/order/list';
export const ECOM_ORDER_DETAILS = '/api/v1/order/';

//Profile
export const GET_PROFILE_V2 = '/api/customer/account/profileV2';
export const CHANGE_PROFILE_INFO = '/api/customer/account/profile/request-change';
export const VERIFY_ADD_PROFILE_INFO = '/api/customer/account/profile/verify-create';
export const VERIFY_UPDATE_PROFILE_INFO = '/api/customer/account/profile/verify-update';
export const DELETE_PROFILE_INFO = '/api/customer/account/profile/request-delete';
export const UPDATE_PRIMARY_USERNAME = '/api/customer/account/profile/update-primary-name';

//Blog
export const GET_ALL_BLOGS = '/cms/blog';
export const BLOG_DETAIL = '/cms/blog-detail/';
export const BLOG_PAGE = '/cms/blog-page';
export const STATES_LIST = '/cms/get-states';
export const CITIES_LIST = '/cms/cities';
export const STORE_LOCATIONS = '/cms/get-efl-locations';
export const SERVICE_CENTERS = '/cms/get-efl-location-details';
export const PINCODE_DATA = '/api/public/location';
//SaleAssist
export const SALE_ASSIST_SLOTS = '/api/public/sale-assist/get-slots';
export const SALE_ASSIST_SCHEDULE_MEET = '/api/public/sale-assist/schedule';

//Cancel Order

export const ECOM_CANCEL_ORDER = '/api/v1/order/cancel';

// Upload Files
export const CMS_UPLOAD_FILES = '/api/cms/upload';

// Grievance Form
export const VERIFY_LEAD = '/api/public/ecom/v1/otp/verifyLead';
export const FREE_SERVICE = '/api/service/freeservice';

export const BOOK_A_VC_DEMO = '/api/schedule/book-a-demo';

export const LIMECHAT_CVF_EVENTS = '/api/public/limechat/cvf-events';

export const BOOK_PREPAID_SERVICE = '/api/service/helpline-prepaid';
